export enum SystemTheme {
  dark =  "dark",
}